document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sc-add-on-product").forEach((scAddonBlock) => {
    if (!scAddonBlock) return;

    const mainCheckbox = scAddonBlock.querySelector(".main-add-on-checkbox");
    const variantId = scAddonBlock.dataset.defaultVariant;
    const optionsDiv = scAddonBlock.querySelector(".sc-add-on-product-options");
    const trainerPropertyInput = scAddonBlock.querySelector(
      'input[name$="[properties][Trainer]"]'
    );
    const quantityInput = scAddonBlock.querySelector(
      'input[name$="[quantity]"]'
    );
    const chooseLaterCheckbox = scAddonBlock.querySelector(
      ".choose-later-checkbox"
    );
    const dropdown = scAddonBlock.querySelector(".trainer-dropdown");
    const selectedTrainer = scAddonBlock.querySelector(
      ".trainer-dropdown__selected"
    );
    const errorMessage = scAddonBlock.querySelector(".error-message");

    const relatedInputs = [trainerPropertyInput, quantityInput].filter(Boolean);

    const placeholderText = scAddonBlock.dataset.textPlaceholder;
    const laterText = scAddonBlock.dataset.textLater;

    const updateScAddonState = () => {
      const hasTrainer =
        trainerPropertyInput &&
        trainerPropertyInput.value.trim() !== "" &&
        trainerPropertyInput.value !== laterText;
      const isLaterChecked = chooseLaterCheckbox && chooseLaterCheckbox.checked;

      const itemIndex = mainCheckbox.dataset.itemIndex;

      if (mainCheckbox.checked && (hasTrainer || isLaterChecked)) {
        mainCheckbox.value = variantId;
        mainCheckbox.setAttribute("name", `items[${itemIndex}][id]`);

        relatedInputs.forEach((input) => (input.disabled = false));
        if (errorMessage) errorMessage.style.display = "none";
        if (optionsDiv) {
          optionsDiv.classList.remove("error-highlight");
        }
      } else {
        mainCheckbox.value = "";
        mainCheckbox.removeAttribute("name");

        relatedInputs.forEach((input) => (input.disabled = true));
      }
    };

    mainCheckbox.addEventListener("change", () => {
      const isChecked = mainCheckbox.checked;
      if (optionsDiv) optionsDiv.style.display = isChecked ? "block" : "none";

      if (!isChecked) {
        if (chooseLaterCheckbox) chooseLaterCheckbox.checked = false;
        if (trainerPropertyInput) trainerPropertyInput.value = "";
        if (selectedTrainer)
          selectedTrainer.innerHTML = `<span>${placeholderText}</span>`;
        if (errorMessage) errorMessage.style.display = "none";
        if (optionsDiv) {
          optionsDiv.classList.remove("error-highlight");
        }
      }

      updateScAddonState();
    });

    const allAddOns = document.querySelectorAll(
      ".add-on-product .main-add-on-checkbox"
    );

    allAddOns.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const currentBlock = checkbox.closest(".add-on-product");

        if (checkbox.checked) {
          allAddOns.forEach((other) => {
            if (other !== checkbox) {
              other.checked = false;

              const otherBlock = other.closest(".add-on-product");
              if (!otherBlock) return;

              const otherOptions = otherBlock.querySelector(
                ".sc-add-on-product-options"
              );
              if (otherOptions) otherOptions.style.display = "none";

              const otherTrainerInput = otherBlock.querySelector(
                'input[name$="[properties][Trainer]"]'
              );
              const otherQuantityInput = otherBlock.querySelector(
                'input[name$="[quantity]"]'
              );

              if (otherTrainerInput) {
                otherTrainerInput.disabled = true;
                otherTrainerInput.value = "";
              }
              if (otherQuantityInput) otherQuantityInput.disabled = true;

              const otherSelected = otherBlock.querySelector(
                ".trainer-dropdown__selected"
              );
              if (otherSelected)
                otherSelected.innerHTML = `<span>${placeholderText}</span>`;

              const otherChooseLater = otherBlock.querySelector(
                ".choose-later-checkbox"
              );
              if (otherChooseLater) otherChooseLater.checked = false;
            }
          });

          const currentOptions = currentBlock?.querySelector(
            ".sc-add-on-product-options"
          );
          if (currentOptions) currentOptions.style.display = "block";
        } else {
          const currentOptions = currentBlock?.querySelector(
            ".sc-add-on-product-options"
          );
          if (currentOptions) currentOptions.style.display = "none";
        }
      });
    });

    if (dropdown) {
      dropdown.querySelectorAll(".trainer-dropdown__item").forEach((item) => {
        item.addEventListener("click", () => {
          const value = item.getAttribute("data-value");
          if (selectedTrainer) selectedTrainer.textContent = value;
          if (trainerPropertyInput) trainerPropertyInput.value = value;
          if (chooseLaterCheckbox) chooseLaterCheckbox.checked = false;
          dropdown.classList.remove("open");
          updateScAddonState();
        });
      });
    }

    if (chooseLaterCheckbox) {
      chooseLaterCheckbox.addEventListener("change", () => {
        if (chooseLaterCheckbox.checked) {
          if (trainerPropertyInput) trainerPropertyInput.value = laterText;
          if (selectedTrainer)
            selectedTrainer.innerHTML = `<span>${placeholderText}</span>`;
        } else {
          if (trainerPropertyInput) trainerPropertyInput.value = "";
        }
        updateScAddonState();
      });
    }

    const addToCartBtn = document.querySelector('button[name="add"]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", (event) => {
        if (mainCheckbox.checked && mainCheckbox.value === "") {
          const errorDiv = scAddonBlock.querySelector(".error-message");
          // if (errorDiv) errorDiv.style.display = "block";
          optionsDiv.classList.add("error-highlight");
          setTimeout(() => {
            optionsDiv.classList.remove("error-highlight");
          }, 10000);
          return;
        }
      });
    }

    updateScAddonState();
  });
  document.querySelectorAll(".trainer-dropdown").forEach((dropdown) => {
    const selected = dropdown.querySelector(".trainer-dropdown__selected");
    const items = dropdown.querySelectorAll(".trainer-dropdown__item");
    const hiddenInput = dropdown
      .closest(".sc-add-on-product")
      .querySelector('input[name$="[properties][Trainer]"]');
    if (!selected || !hiddenInput) return;

    selected.addEventListener("click", () => dropdown.classList.toggle("open"));
    items.forEach((item) => {
      item.addEventListener("click", () => {
        const value = item.getAttribute("data-value");
        selected.innerHTML = `<p>${value}</p>`;
        hiddenInput.value = value;
        const chooseLaterCheckbox = dropdown
          .closest(".sc-add-on-product")
          .querySelector(".choose-later-checkbox");
        if (chooseLaterCheckbox) chooseLaterCheckbox.checked = false;
        dropdown.classList.remove("open");
      });
    });
    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target)) dropdown.classList.remove("open");
    });
  });

  document
    .querySelectorAll(".choose-later-checkbox")
    .forEach((chooseLaterCheckbox) => {
      chooseLaterCheckbox.addEventListener("change", () => {
        const scAddonBlock = chooseLaterCheckbox.closest(".sc-add-on-product");
        const trainerPropertyInput = scAddonBlock.querySelector(
          'input[name$="[properties][Trainer]"]'
        );
        const selectedTrainer = scAddonBlock.querySelector(
          ".trainer-dropdown__selected"
        );

        if (chooseLaterCheckbox.checked) {
          if (trainerPropertyInput) trainerPropertyInput.value = laterText;
          if (selectedTrainer)
            selectedTrainer.innerHTML = `<span>${placeholderText}</span>`;
        } else {
          if (trainerPropertyInput) trainerPropertyInput.value = "";
        }
      });
    });

  document.querySelectorAll(".tooltip-trigger").forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const tooltipId = trigger.getAttribute("data-tooltip-id");
      const tooltip = document.getElementById(tooltipId);
      if (tooltip) tooltip.style.display = "flex";
    });
  });

  document.querySelectorAll(".tooltip-popup").forEach((popup) => {
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        popup.style.display = "none";
      }
    });
  });

  document.querySelectorAll(".tooltip-close").forEach((closeBtn) => {
    closeBtn.addEventListener("click", () => {
      closeBtn.closest(".tooltip-popup").style.display = "none";
    });
  });
});
